export const environment = {
  production: true,
  mapbox: {
    accessToken: 'pk.eyJ1Ijoic2VsbG51IiwiYSI6ImNrNTU5MmVsdDBycDEza3Q3ZGprcXQwMTMifQ.0WOgZMi7JdoS4tXkXIW_dg'
  }
};
